// Extracted from nature .babylon file
// 2 mesh(es), 2 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const NATURE_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.01960000, 0.16470000, 0.00780000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const NATURE_MESH_0: RuneMesh = {
  name: "Nature_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    0.01890000, 0.43310001, 0.58569992,
    0.01890000, 0.43310001, 0.58569992,
    0.01890000, 0.43310001, 0.58569992,
    0.20580000, 0.43310001, 0.57549995,
    0.20580000, 0.43310001, 0.57549995,
    0.11750000, 0.43309999, 0.02179997,
    0.11750000, 0.43309999, 0.02179997,
    0.35179999, 0.43309999, -0.07330003,
    0.35179999, 0.43309999, -0.07330003,
    0.35179999, 0.43309999, -0.07330003,
    0.52509999, 0.43309996, -0.30090004,
    0.52509999, 0.43309996, -0.30090004,
    0.43340001, 0.43309996, -0.54200006,
    0.43340001, 0.43309996, -0.54200006,
    0.03250000, 0.43309993, -0.62700003,
    0.03250000, 0.43309993, -0.62700003,
    -0.39550000, 0.43309996, -0.57940006,
    -0.39550000, 0.43309996, -0.57940006,
    -0.49399999, 0.43309996, -0.34840003,
    -0.49399999, 0.43309996, -0.34840003,
    -0.29359999, 0.43309999, -0.11060003,
    -0.29359999, 0.43309999, -0.11060003,
    -0.10670000, 0.43309999, -0.01890003,
    -0.10670000, 0.43309999, -0.01890003,
    -0.25960001, 0.43310001, 0.54499996,
    -0.25960001, 0.43310001, 0.54499996,
    -0.06260000, 0.43310001, 0.53479993,
    -0.06260000, 0.43310001, 0.53479993,
    -0.01500000, 0.43309999, -0.06990003,
    -0.01500000, 0.43309999, -0.06990003,
    -0.20860000, 0.43309999, -0.16160002,
    -0.20860000, 0.43309999, -0.16160002,
    -0.20860000, 0.43309999, -0.16160002,
    -0.30039999, 0.43309996, -0.34840003,
    -0.30039999, 0.43309996, -0.34840003,
    -0.21540000, 0.43309996, -0.49110004,
    -0.21540000, 0.43309996, -0.49110004,
    0.02570000, 0.43309996, -0.54200006,
    0.02570000, 0.43309996, -0.54200006,
    0.25330001, 0.43309996, -0.44690004,
    0.25330001, 0.43309996, -0.44690004,
    0.25330001, 0.43309996, -0.44690004,
    0.34840000, 0.43309996, -0.30430004,
    0.34840000, 0.43309996, -0.30430004,
    0.25330001, 0.43309999, -0.11060003,
    0.25330001, 0.43309999, -0.11060003,
    0.05630000, 0.43309999, -0.01550003,
    0.05630000, 0.43309999, -0.01550003,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    -0.25960001, 0.36250004, 0.54500002,
    -0.06260000, 0.36250004, 0.53479999,
    -0.01500000, 0.36250001, -0.06990003,
    -0.10670000, 0.36250001, -0.01890003,
    -0.29359999, 0.36250001, -0.11060003,
    -0.49399999, 0.36249998, -0.34840003,
    -0.39550000, 0.36249998, -0.57940000,
    0.03250000, 0.36249995, -0.62699997,
    0.43340001, 0.36249998, -0.54200000,
    0.52509999, 0.36249998, -0.30090004,
    0.35179999, 0.36250001, -0.07330003,
    0.11750000, 0.36250001, 0.02179997,
    0.20580000, 0.36250004, 0.57550001,
    0.01890000, 0.36250004, 0.58569998,
    0.05630000, 0.36250001, -0.01550003,
    0.25330001, 0.36250001, -0.11060003,
    0.34840000, 0.36249998, -0.30430004,
    0.25330001, 0.36249998, -0.44690004,
    0.25330001, 0.36249998, -0.44690004,
    0.02570000, 0.36249998, -0.54200000,
    -0.21540000, 0.36249998, -0.49110004,
    -0.30039999, 0.36249998, -0.34840003,
    -0.20860000, 0.36250001, -0.16160002,
    -0.20860000, 0.36250001, -0.16160002,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 47, 45, 626, 47, 626, 625,
    79, 80, 1, 79, 1, 0, 1, 81, 82, 1, 82, 2,
    3, 2, 83, 3, 83, 4, 4, 83, 84, 4, 84, 5,
    5, 84, 85, 5, 85, 6, 6, 85, 86, 6, 86, 7,
    7, 86, 87, 7, 87, 8, 8, 87, 88, 8, 88, 9,
    9, 88, 89, 9, 89, 10, 10, 89, 90, 10, 90, 11,
    11, 90, 91, 11, 91, 12, 12, 91, 92, 12, 92, 13,
    13, 92, 93, 13, 93, 14, 14, 93, 94, 14, 94, 15,
    15, 94, 95, 15, 95, 16, 16, 95, 96, 16, 96, 17,
    17, 96, 97, 17, 97, 18, 18, 97, 98, 18, 98, 19,
    19, 98, 99, 19, 99, 20, 20, 99, 100, 20, 100, 21,
    21, 100, 101, 21, 101, 22, 22, 101, 102, 22, 102, 23,
    23, 102, 103, 23, 103, 24, 24, 103, 104, 24, 104, 73,
    73, 104, 105, 73, 105, 74, 74, 105, 106, 74, 106, 75,
    75, 106, 107, 75, 107, 76, 76, 107, 108, 76, 108, 77,
    77, 108, 109, 77, 109, 78, 78, 109, 80, 78, 80, 79,
    80, 110, 81, 80, 81, 1, 81, 111, 112, 81, 112, 82,
    2, 82, 113, 2, 113, 83, 83, 113, 114, 83, 114, 84,
    84, 114, 115, 84, 115, 85, 85, 115, 116, 85, 116, 86,
    86, 116, 117, 86, 117, 87, 87, 117, 118, 87, 118, 88,
    88, 118, 119, 88, 119, 89, 89, 119, 120, 89, 120, 90,
    90, 120, 121, 90, 121, 91, 91, 121, 122, 91, 122, 92,
    92, 122, 123, 92, 123, 93, 93, 123, 124, 93, 124, 94,
    94, 124, 125, 94, 125, 95, 95, 125, 126, 95, 126, 96,
    96, 126, 127, 96, 127, 97, 97, 127, 128, 97, 128, 98,
    98, 128, 129, 98, 129, 99, 99, 129, 130, 99, 130, 100,
    100, 130, 131, 100, 131, 101, 101, 131, 132, 101, 132, 102,
    102, 132, 133, 102, 133, 103, 103, 133, 134, 103, 134, 104,
    104, 134, 135, 104, 135, 105, 105, 135, 136, 105, 136, 106,
    106, 136, 137, 106, 137, 107, 107, 137, 138, 107, 138, 108,
    108, 138, 139, 108, 139, 109, 109, 139, 110, 109, 110, 80,
    110, 140, 111, 110, 111, 81, 111, 141, 142, 111, 142, 112,
    82, 112, 143, 82, 143, 113, 113, 143, 144, 113, 144, 114,
    114, 144, 145, 114, 145, 115, 115, 145, 146, 115, 146, 116,
    116, 146, 147, 116, 147, 117, 117, 147, 148, 117, 148, 118,
    118, 148, 149, 118, 149, 119, 119, 149, 150, 119, 150, 120,
    120, 150, 151, 120, 151, 121, 121, 151, 152, 121, 152, 122,
    122, 152, 153, 122, 153, 123, 123, 153, 154, 123, 154, 124,
    124, 154, 155, 124, 155, 125, 125, 155, 156, 125, 156, 126,
    126, 156, 157, 126, 157, 127, 127, 157, 158, 127, 158, 128,
    128, 158, 159, 128, 159, 129, 129, 159, 160, 129, 160, 130,
    130, 160, 161, 130, 161, 131, 131, 161, 162, 131, 162, 132,
    132, 162, 163, 132, 163, 133, 133, 163, 164, 133, 164, 134,
    134, 164, 165, 134, 165, 135, 135, 165, 166, 135, 166, 136,
    136, 166, 167, 136, 167, 137, 137, 167, 168, 137, 168, 138,
    138, 168, 169, 138, 169, 139, 139, 169, 140, 139, 140, 110,
    140, 170, 141, 140, 141, 111, 141, 171, 172, 141, 172, 142,
    112, 142, 173, 112, 173, 143, 143, 173, 174, 143, 174, 144,
    144, 174, 175, 144, 175, 145, 145, 175, 176, 145, 176, 146,
    146, 176, 177, 146, 177, 147, 147, 177, 178, 147, 178, 148,
    148, 178, 179, 148, 179, 149, 149, 179, 180, 149, 180, 150,
    150, 180, 181, 150, 181, 151, 151, 181, 182, 151, 182, 152,
    152, 182, 183, 152, 183, 153, 153, 183, 184, 153, 184, 154,
    154, 184, 185, 154, 185, 155, 155, 185, 186, 155, 186, 156,
    156, 186, 187, 156, 187, 157, 157, 187, 188, 157, 188, 158,
    158, 188, 189, 158, 189, 159, 159, 189, 190, 159, 190, 160,
    160, 190, 191, 160, 191, 161, 161, 191, 192, 161, 192, 162,
    162, 192, 193, 162, 193, 163, 163, 193, 194, 163, 194, 164,
    164, 194, 195, 164, 195, 165, 165, 195, 196, 165, 196, 166,
    166, 196, 197, 166, 197, 167, 167, 197, 198, 167, 198, 168,
    168, 198, 199, 168, 199, 169, 169, 199, 170, 169, 170, 140,
    170, 200, 171, 170, 171, 141, 171, 201, 202, 171, 202, 172,
    142, 172, 203, 142, 203, 173, 173, 203, 204, 173, 204, 174,
    174, 204, 205, 174, 205, 175, 175, 205, 206, 175, 206, 176,
    176, 206, 207, 176, 207, 177, 177, 207, 208, 177, 208, 178,
    178, 208, 209, 178, 209, 179, 179, 209, 210, 179, 210, 180,
    180, 210, 211, 180, 211, 181, 181, 211, 212, 181, 212, 182,
    182, 212, 213, 182, 213, 183, 183, 213, 214, 183, 214, 184,
    184, 214, 215, 184, 215, 185, 185, 215, 216, 185, 216, 186,
    186, 216, 217, 186, 217, 187, 187, 217, 218, 187, 218, 188,
    188, 218, 219, 188, 219, 189, 189, 219, 220, 189, 220, 190,
    190, 220, 221, 190, 221, 191, 191, 221, 222, 191, 222, 192,
    192, 222, 223, 192, 223, 193, 193, 223, 224, 193, 224, 194,
    194, 224, 225, 194, 225, 195, 195, 225, 226, 195, 226, 196,
    196, 226, 227, 196, 227, 197, 197, 227, 228, 197, 228, 198,
    198, 228, 229, 198, 229, 199, 199, 229, 200, 199, 200, 170,
    200, 230, 201, 200, 201, 171, 201, 233, 235, 201, 235, 202,
    172, 202, 236, 172, 236, 203, 203, 236, 237, 203, 237, 204,
    204, 237, 238, 204, 238, 205, 205, 238, 239, 205, 239, 206,
    206, 239, 240, 206, 240, 207, 207, 240, 241, 207, 241, 208,
    208, 241, 242, 208, 242, 209, 209, 242, 243, 209, 243, 210,
    210, 243, 244, 210, 244, 211, 211, 244, 245, 211, 245, 212,
    212, 245, 246, 212, 246, 213, 213, 246, 247, 213, 247, 214,
    214, 247, 248, 214, 248, 215, 215, 248, 249, 215, 249, 216,
    216, 249, 250, 216, 250, 217, 217, 250, 251, 217, 251, 218,
    218, 251, 252, 218, 252, 219, 219, 252, 253, 219, 253, 220,
    220, 253, 254, 220, 254, 221, 221, 254, 255, 221, 255, 222,
    222, 255, 256, 222, 256, 223, 223, 256, 257, 223, 257, 224,
    224, 257, 258, 224, 258, 225, 225, 258, 259, 225, 259, 226,
    226, 259, 260, 226, 260, 227, 227, 260, 261, 227, 261, 228,
    228, 261, 262, 228, 262, 229, 229, 262, 230, 229, 230, 200,
    230, 264, 233, 230, 233, 201, 231, 265, 267, 231, 267, 234,
    202, 235, 269, 202, 269, 236, 236, 269, 271, 236, 271, 237,
    237, 271, 273, 237, 273, 238, 238, 273, 275, 238, 275, 239,
    239, 275, 277, 239, 277, 240, 240, 277, 279, 240, 279, 241,
    241, 279, 281, 241, 281, 242, 242, 281, 283, 242, 283, 243,
    243, 283, 284, 243, 284, 244, 244, 284, 286, 244, 286, 245,
    245, 286, 288, 245, 288, 246, 246, 288, 290, 246, 290, 247,
    247, 290, 292, 247, 292, 248, 248, 292, 294, 248, 294, 249,
    249, 294, 296, 249, 296, 250, 250, 296, 298, 250, 298, 251,
    251, 298, 300, 251, 300, 252, 252, 300, 302, 252, 302, 253,
    253, 302, 304, 253, 304, 254, 254, 304, 306, 254, 306, 255,
    255, 306, 308, 255, 308, 256, 256, 308, 310, 256, 310, 257,
    257, 310, 312, 257, 312, 258, 258, 312, 314, 258, 314, 259,
    259, 314, 316, 259, 316, 260, 260, 316, 319, 260, 319, 261,
    261, 319, 321, 261, 321, 262, 262, 321, 264, 262, 264, 230,
    263, 322, 266, 263, 266, 232, 265, 323, 326, 265, 326, 267,
    234, 267, 328, 234, 328, 268, 268, 328, 329, 268, 329, 270,
    270, 329, 330, 270, 330, 272, 272, 330, 331, 272, 331, 274,
    274, 331, 332, 274, 332, 276, 276, 332, 333, 276, 333, 278,
    278, 333, 334, 278, 334, 280, 280, 334, 335, 280, 335, 282,
    282, 335, 336, 282, 336, 285, 285, 336, 337, 285, 337, 287,
    287, 337, 338, 287, 338, 289, 289, 338, 339, 289, 339, 291,
    291, 339, 340, 291, 340, 293, 293, 340, 341, 293, 341, 295,
    295, 341, 342, 295, 342, 297, 297, 342, 343, 297, 343, 299,
    299, 343, 344, 299, 344, 301, 301, 344, 345, 301, 345, 303,
    303, 345, 346, 303, 346, 305, 305, 346, 347, 305, 347, 307,
    307, 347, 348, 307, 348, 309, 309, 348, 349, 309, 349, 311,
    311, 349, 350, 311, 350, 313, 313, 350, 351, 313, 351, 315,
    315, 351, 352, 315, 352, 317, 317, 352, 353, 317, 353, 318,
    318, 353, 354, 318, 354, 320, 320, 354, 322, 320, 322, 263,
    322, 355, 325, 322, 325, 266, 324, 357, 358, 324, 358, 327,
    267, 326, 359, 267, 359, 328, 328, 359, 361, 328, 361, 329,
    329, 361, 363, 329, 363, 330, 330, 363, 365, 330, 365, 331,
    331, 365, 367, 331, 367, 332, 332, 367, 369, 332, 369, 333,
    333, 369, 371, 333, 371, 334, 334, 371, 373, 334, 373, 335,
    335, 373, 376, 335, 376, 336, 336, 376, 378, 336, 378, 337,
    337, 378, 380, 337, 380, 338, 338, 380, 382, 338, 382, 339,
    339, 382, 384, 339, 384, 340, 340, 384, 386, 340, 386, 341,
    341, 386, 388, 341, 388, 342, 342, 388, 390, 342, 390, 343,
    343, 390, 392, 343, 392, 344, 344, 392, 394, 344, 394, 345,
    345, 394, 396, 345, 396, 346, 346, 396, 398, 346, 398, 347,
    347, 398, 400, 347, 400, 348, 348, 400, 402, 348, 402, 349,
    349, 402, 404, 349, 404, 350, 350, 404, 406, 350, 406, 351,
    351, 406, 408, 351, 408, 352, 352, 408, 409, 352, 409, 353,
    353, 409, 411, 353, 411, 354, 354, 411, 355, 354, 355, 322,
    356, 413, 357, 356, 357, 324, 357, 414, 415, 357, 415, 358,
    327, 358, 416, 327, 416, 360, 360, 416, 417, 360, 417, 362,
    362, 417, 418, 362, 418, 364, 364, 418, 419, 364, 419, 366,
    366, 419, 420, 366, 420, 368, 368, 420, 421, 368, 421, 370,
    370, 421, 422, 370, 422, 372, 372, 422, 423, 372, 423, 374,
    374, 423, 424, 374, 424, 375, 375, 424, 425, 375, 425, 377,
    377, 425, 426, 377, 426, 379, 379, 426, 427, 379, 427, 381,
    381, 427, 428, 381, 428, 383, 383, 428, 429, 383, 429, 385,
    385, 429, 430, 385, 430, 387, 387, 430, 431, 387, 431, 389,
    389, 431, 432, 389, 432, 391, 391, 432, 433, 391, 433, 393,
    393, 433, 434, 393, 434, 395, 395, 434, 435, 395, 435, 397,
    397, 435, 436, 397, 436, 399, 399, 436, 437, 399, 437, 401,
    401, 437, 438, 401, 438, 403, 403, 438, 439, 403, 439, 405,
    405, 439, 440, 405, 440, 407, 407, 440, 441, 407, 441, 410,
    410, 441, 442, 410, 442, 412, 412, 442, 413, 412, 413, 356,
    413, 443, 414, 413, 414, 357, 414, 444, 445, 414, 445, 415,
    358, 415, 446, 358, 446, 416, 416, 446, 447, 416, 447, 417,
    417, 447, 448, 417, 448, 418, 418, 448, 449, 418, 449, 419,
    419, 449, 450, 419, 450, 420, 420, 450, 451, 420, 451, 421,
    421, 451, 452, 421, 452, 422, 422, 452, 453, 422, 453, 423,
    423, 453, 454, 423, 454, 424, 424, 454, 455, 424, 455, 425,
    425, 455, 456, 425, 456, 426, 426, 456, 457, 426, 457, 427,
    427, 457, 458, 427, 458, 428, 428, 458, 459, 428, 459, 429,
    429, 459, 460, 429, 460, 430, 430, 460, 461, 430, 461, 431,
    431, 461, 462, 431, 462, 432, 432, 462, 463, 432, 463, 433,
    433, 463, 464, 433, 464, 434, 434, 464, 465, 434, 465, 435,
    435, 465, 466, 435, 466, 436, 436, 466, 467, 436, 467, 437,
    437, 467, 468, 437, 468, 438, 438, 468, 469, 438, 469, 439,
    439, 469, 470, 439, 470, 440, 440, 470, 471, 440, 471, 441,
    441, 471, 472, 441, 472, 442, 442, 472, 443, 442, 443, 413,
    443, 473, 444, 443, 444, 414, 444, 474, 475, 444, 475, 445,
    415, 445, 476, 415, 476, 446, 446, 476, 477, 446, 477, 447,
    447, 477, 478, 447, 478, 448, 448, 478, 479, 448, 479, 449,
    449, 479, 480, 449, 480, 450, 450, 480, 481, 450, 481, 451,
    451, 481, 482, 451, 482, 452, 452, 482, 483, 452, 483, 453,
    453, 483, 484, 453, 484, 454, 454, 484, 485, 454, 485, 455,
    455, 485, 486, 455, 486, 456, 456, 486, 487, 456, 487, 457,
    457, 487, 488, 457, 488, 458, 458, 488, 489, 458, 489, 459,
    459, 489, 490, 459, 490, 460, 460, 490, 491, 460, 491, 461,
    461, 491, 492, 461, 492, 462, 462, 492, 493, 462, 493, 463,
    463, 493, 494, 463, 494, 464, 464, 494, 495, 464, 495, 465,
    465, 495, 496, 465, 496, 466, 466, 496, 497, 466, 497, 467,
    467, 497, 498, 467, 498, 468, 468, 498, 499, 468, 499, 469,
    469, 499, 500, 469, 500, 470, 470, 500, 501, 470, 501, 471,
    471, 501, 502, 471, 502, 472, 472, 502, 473, 472, 473, 443,
    473, 503, 474, 473, 474, 444, 474, 504, 505, 474, 505, 475,
    445, 475, 506, 445, 506, 476, 476, 506, 507, 476, 507, 477,
    477, 507, 508, 477, 508, 478, 478, 508, 509, 478, 509, 479,
    479, 509, 510, 479, 510, 480, 480, 510, 511, 480, 511, 481,
    481, 511, 512, 481, 512, 482, 482, 512, 513, 482, 513, 483,
    483, 513, 514, 483, 514, 484, 484, 514, 515, 484, 515, 485,
    485, 515, 516, 485, 516, 486, 486, 516, 517, 486, 517, 487,
    487, 517, 518, 487, 518, 488, 488, 518, 519, 488, 519, 489,
    489, 519, 520, 489, 520, 490, 490, 520, 521, 490, 521, 491,
    491, 521, 522, 491, 522, 492, 492, 522, 523, 492, 523, 493,
    493, 523, 524, 493, 524, 494, 494, 524, 525, 494, 525, 495,
    495, 525, 526, 495, 526, 496, 496, 526, 527, 496, 527, 497,
    497, 527, 528, 497, 528, 498, 498, 528, 529, 498, 529, 499,
    499, 529, 530, 499, 530, 500, 500, 530, 531, 500, 531, 501,
    501, 531, 532, 501, 532, 502, 502, 532, 503, 502, 503, 473,
    503, 533, 504, 503, 504, 474, 504, 534, 535, 504, 535, 505,
    475, 505, 536, 475, 536, 506, 506, 536, 537, 506, 537, 507,
    507, 537, 538, 507, 538, 508, 508, 538, 539, 508, 539, 509,
    509, 539, 540, 509, 540, 510, 510, 540, 541, 510, 541, 511,
    511, 541, 542, 511, 542, 512, 512, 542, 543, 512, 543, 513,
    513, 543, 544, 513, 544, 514, 514, 544, 545, 514, 545, 515,
    515, 545, 546, 515, 546, 516, 516, 546, 547, 516, 547, 517,
    517, 547, 548, 517, 548, 518, 518, 548, 549, 518, 549, 519,
    519, 549, 550, 519, 550, 520, 520, 550, 551, 520, 551, 521,
    521, 551, 552, 521, 552, 522, 522, 552, 553, 522, 553, 523,
    523, 553, 554, 523, 554, 524, 524, 554, 555, 524, 555, 525,
    525, 555, 556, 525, 556, 526, 526, 556, 557, 526, 557, 527,
    527, 557, 558, 527, 558, 528, 528, 558, 559, 528, 559, 529,
    529, 559, 560, 529, 560, 530, 530, 560, 561, 530, 561, 531,
    531, 561, 562, 531, 562, 532, 532, 562, 533, 532, 533, 503,
    533, 563, 534, 533, 534, 504, 534, 564, 565, 534, 565, 535,
    505, 535, 566, 505, 566, 536, 536, 566, 567, 536, 567, 537,
    537, 567, 568, 537, 568, 538, 538, 568, 569, 538, 569, 539,
    539, 569, 570, 539, 570, 540, 540, 570, 571, 540, 571, 541,
    541, 571, 572, 541, 572, 542, 542, 572, 573, 542, 573, 543,
    543, 573, 574, 543, 574, 544, 544, 574, 575, 544, 575, 545,
    545, 575, 576, 545, 576, 546, 546, 576, 577, 546, 577, 547,
    547, 577, 578, 547, 578, 548, 548, 578, 579, 548, 579, 549,
    549, 579, 580, 549, 580, 550, 550, 580, 581, 550, 581, 551,
    551, 581, 582, 551, 582, 552, 552, 582, 583, 552, 583, 553,
    553, 583, 584, 553, 584, 554, 554, 584, 585, 554, 585, 555,
    555, 585, 586, 555, 586, 556, 556, 586, 587, 556, 587, 557,
    557, 587, 588, 557, 588, 558, 558, 588, 589, 558, 589, 559,
    559, 589, 590, 559, 590, 560, 560, 590, 591, 560, 591, 561,
    561, 591, 592, 561, 592, 562, 562, 592, 563, 562, 563, 533,
    563, 593, 564, 563, 564, 534, 564, 594, 565, 535, 565, 595,
    535, 595, 566, 566, 595, 596, 566, 596, 567, 567, 596, 597,
    567, 597, 568, 568, 597, 598, 568, 598, 569, 569, 598, 599,
    569, 599, 570, 570, 599, 600, 570, 600, 571, 571, 600, 601,
    571, 601, 572, 572, 601, 602, 572, 602, 573, 573, 602, 603,
    573, 603, 574, 574, 603, 604, 574, 604, 575, 575, 604, 605,
    575, 605, 576, 576, 605, 606, 576, 606, 577, 577, 606, 607,
    577, 607, 578, 578, 607, 608, 578, 608, 579, 579, 608, 609,
    579, 609, 580, 580, 609, 610, 580, 610, 581, 581, 610, 611,
    581, 611, 582, 582, 611, 612, 582, 612, 583, 583, 612, 613,
    583, 613, 584, 584, 613, 614, 584, 614, 585, 585, 614, 615,
    585, 615, 586, 586, 615, 616, 586, 616, 587, 587, 616, 617,
    587, 617, 588, 588, 617, 618, 588, 618, 589, 589, 618, 619,
    589, 619, 590, 590, 619, 620, 590, 620, 591, 591, 620, 621,
    591, 621, 592, 592, 621, 593, 592, 593, 563, 593, 594, 564,
    565, 594, 595, 595, 594, 596, 596, 594, 597, 597, 594, 598,
    598, 594, 599, 599, 594, 600, 600, 594, 601, 601, 594, 602,
    602, 594, 603, 603, 594, 604, 604, 594, 605, 605, 594, 606,
    606, 594, 607, 607, 594, 608, 608, 594, 609, 609, 594, 610,
    610, 594, 611, 611, 594, 612, 612, 594, 613, 613, 594, 614,
    614, 594, 615, 615, 594, 616, 616, 594, 617, 617, 594, 618,
    618, 594, 619, 619, 594, 620, 620, 594, 621, 621, 594, 593,
    51, 49, 622, 51, 622, 623, 53, 51, 623, 53, 623, 624,
    49, 47, 625, 49, 625, 622, 55, 53, 624, 55, 624, 644,
    58, 57, 645, 58, 645, 643, 60, 58, 643, 60, 643, 642,
    62, 60, 642, 62, 642, 641, 64, 62, 641, 64, 641, 639,
    67, 66, 640, 67, 640, 638, 69, 67, 638, 69, 638, 637,
    71, 69, 637, 71, 637, 636, 26, 71, 636, 26, 636, 635,
    28, 25, 635, 28, 635, 634, 30, 28, 634, 30, 634, 633,
    32, 30, 633, 32, 633, 632, 35, 32, 632, 35, 632, 631,
    37, 35, 631, 37, 631, 630, 39, 37, 630, 39, 630, 629,
    41, 39, 629, 41, 629, 628, 43, 41, 628, 43, 628, 627,
    45, 43, 627, 45, 627, 626, 23, 24, 27, 29, 31, 33,
    23, 27, 29, 21, 22, 23, 33, 20, 21, 23, 29, 33,
    33, 21, 23, 54, 56, 59, 59, 61, 63, 63, 65, 68,
    68, 70, 72, 27, 24, 73, 63, 68, 72, 72, 27, 73,
    73, 74, 75, 75, 76, 77, 77, 78, 79, 79, 0, 3,
    3, 4, 5, 5, 6, 7, 7, 8, 9, 9, 10, 11,
    11, 12, 13, 13, 14, 15, 15, 16, 17, 17, 18, 19,
    19, 20, 34, 19, 34, 36, 15, 17, 19, 11, 13, 15,
    7, 9, 11, 3, 5, 7, 77, 79, 3, 73, 75, 77,
    63, 72, 73, 54, 59, 63, 52, 54, 63, 73, 77, 3,
    15, 19, 36, 15, 36, 38, 52, 63, 73, 46, 48, 50,
    50, 52, 73, 11, 15, 38, 11, 38, 40, 50, 73, 3,
    44, 46, 50, 11, 40, 42, 44, 50, 3, 7, 11, 42,
    42, 44, 3, 3, 7, 42,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00590011, 0.99841888, 0.05590106,
    0.44010174, 0.78460313, -0.43670172,
    0.44002109, 0.78463767, -0.43672093,
    0.44002109, 0.78463767, -0.43672093,
    -0.63822372, -0.57212127, -0.51511914,
    -0.63822372, -0.57212127, -0.51511914,
    -0.70309440, 0.59029530, -0.39649682,
    -0.70309440, 0.59029530, -0.39649682,
    -0.46051164, -0.65221647, -0.60211519,
    -0.46051164, -0.65221647, -0.60211519,
    -0.46059041, -0.65218643, -0.60208748,
    -0.78240975, -0.61240759, -0.11310140,
    -0.78240975, -0.61240759, -0.11310140,
    -0.51358714, -0.61358472, 0.59978499,
    -0.51361869, -0.61352234, 0.59982179,
    -0.03629869, -0.67297573, 0.73877335,
    -0.03629869, -0.67297573, 0.73877335,
    0.47300462, -0.60930599, 0.63640619,
    0.47300462, -0.60930599, 0.63640619,
    0.78669617, -0.60599705, -0.11779943,
    0.78669617, -0.60599705, -0.11779943,
    0.46069957, -0.66359942, -0.58939945,
    0.46066904, -0.66365534, -0.58936035,
    0.73688569, 0.58808861, -0.33339356,
    0.73688569, 0.58808861, -0.33339356,
    0.64347836, -0.56248114, -0.51918260,
    0.64347836, -0.56248114, -0.51918260,
    -0.56599372, -0.58449351, -0.58139353,
    -0.56599372, -0.58449351, -0.58139353,
    -0.69300973, -0.59890842, 0.40130564,
    -0.69300973, -0.59890842, 0.40130564,
    -0.53958163, 0.63987825, 0.54718140,
    -0.53958163, 0.63987825, 0.54718140,
    -0.53961116, 0.63991326, 0.54711133,
    -0.78867831, 0.61398318, -0.03179913,
    -0.78867831, 0.61398318, -0.03179913,
    -0.45328667, 0.62698156, -0.63358134,
    -0.45328667, 0.62698156, -0.63358134,
    0.07149817, 0.64588352, -0.76008058,
    0.07149817, 0.64588352, -0.76008058,
    0.48471878, 0.64742512, -0.58812279,
    0.48471878, 0.64742512, -0.58812279,
    0.48468739, 0.64748317, -0.58808476,
    0.79056190, 0.61017059, -0.05199750,
    0.79056190, 0.61017059, -0.05199750,
    0.54110960, 0.64061133, 0.54480962,
    0.54110960, 0.64061133, 0.54480962,
    0.65829197, -0.60919258, 0.44219462,
    0.65829197, -0.60919258, 0.44219462,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    0.64347836, 0.56248114, -0.51918260,
    -0.56599372, 0.58449351, -0.58139353,
    -0.69300973, 0.59890842, 0.40130564,
    0.73688569, -0.58808861, -0.33339356,
    0.46069957, 0.66359942, -0.58939945,
    0.78669617, 0.60599705, -0.11779943,
    0.47300462, 0.60930599, 0.63640619,
    -0.03629869, 0.67297573, 0.73877335,
    -0.51358714, 0.61358472, 0.59978499,
    -0.78240975, 0.61240759, -0.11310140,
    -0.46051164, 0.65221647, -0.60211519,
    -0.70309440, -0.59029530, -0.39649682,
    -0.63822372, 0.57212127, -0.51511914,
    0.58246557, 0.57146624, -0.57806591,
    0.65829197, 0.60919258, 0.44219462,
    0.54110960, -0.64061133, 0.54480962,
    0.79056190, -0.61017059, -0.05199750,
    0.48471878, -0.64742512, -0.58812279,
    0.48468739, -0.64748317, -0.58808476,
    0.07149817, -0.64588352, -0.76008058,
    -0.45328667, -0.62698156, -0.63358134,
    -0.78867831, -0.61398318, -0.03179913,
    -0.53958163, -0.63987825, 0.54718140,
    -0.53961116, -0.63991326, 0.54711133,
  ]),
  materialIndex: 0,
};

const NATURE_MESH_1: RuneMesh = {
  name: "Nature_Rune_primitive1",
  positions: new Float32Array([
    -0.25960001, 0.36250004, 0.54500002,
    -0.06260000, 0.36250004, 0.53479999,
    -0.01500000, 0.36250001, -0.06990003,
    -0.10670000, 0.36250001, -0.01890003,
    -0.29359999, 0.36250001, -0.11060003,
    -0.49399999, 0.36249998, -0.34840003,
    -0.39550000, 0.36249998, -0.57940000,
    0.03250000, 0.36249995, -0.62699997,
    0.43340001, 0.36249998, -0.54200000,
    0.52509999, 0.36249998, -0.30090004,
    0.35179999, 0.36250001, -0.07330003,
    0.11750000, 0.36250001, 0.02179997,
    0.20580000, 0.36250004, 0.57550001,
    0.01890000, 0.36250004, 0.58569998,
    0.05630000, 0.36250001, -0.01550003,
    0.25330001, 0.36250001, -0.11060003,
    0.34840000, 0.36249998, -0.30430004,
    0.25330001, 0.36249998, -0.44690004,
    0.02570000, 0.36249998, -0.54200000,
    -0.21540000, 0.36249998, -0.49110004,
    -0.30039999, 0.36249998, -0.34840003,
    -0.20860000, 0.36250001, -0.16160002,
  ]),
  indices: new Uint16Array([
    2, 1, 0, 3, 4, 5, 2, 0, 3, 21, 2, 3,
    5, 6, 7, 7, 8, 9, 9, 10, 11, 11, 12, 13,
    21, 3, 5, 11, 13, 14, 11, 14, 15, 20, 21, 5,
    19, 20, 5, 9, 11, 15, 9, 15, 16, 19, 5, 7,
    18, 19, 7, 9, 16, 17, 17, 18, 7, 7, 9, 17,
  ]),
  normals: new Float32Array([
    0.64347836, 0.56248114, -0.51918260,
    -0.56599372, 0.58449351, -0.58139353,
    -0.69300973, 0.59890842, 0.40130564,
    0.73688569, -0.58808861, -0.33339356,
    0.46069957, 0.66359942, -0.58939945,
    0.78669617, 0.60599705, -0.11779943,
    0.47300462, 0.60930599, 0.63640619,
    -0.03629869, 0.67297573, 0.73877335,
    -0.51358714, 0.61358472, 0.59978499,
    -0.78240975, 0.61240759, -0.11310140,
    -0.46051164, 0.65221647, -0.60211519,
    -0.70309440, -0.59029530, -0.39649682,
    -0.63822372, 0.57212127, -0.51511914,
    0.58246557, 0.57146624, -0.57806591,
    0.65829197, 0.60919258, 0.44219462,
    0.54107493, -0.64067030, 0.54477471,
    0.79061015, -0.61010779, -0.05200067,
    0.48468739, -0.64748317, -0.58808476,
    0.07150362, -0.64593260, -0.76003836,
    -0.45328667, -0.62698156, -0.63358134,
    -0.78867831, -0.61398318, -0.03179913,
    -0.53958163, -0.63987825, 0.54718140,
  ]),
  materialIndex: 1,
};

export const NATURE_MESHES: RuneMesh[] = [
  NATURE_MESH_0,
  NATURE_MESH_1,
];
